/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlannedLaborCostDto } from '../../models/planned-labor-cost-dto';

export interface GetPlannedLaborCost$Params {
  id: string;
}

export function getPlannedLaborCost(http: HttpClient, rootUrl: string, params: GetPlannedLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<PlannedLaborCostDto>> {
  const rb = new RequestBuilder(rootUrl, getPlannedLaborCost.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlannedLaborCostDto>;
    })
  );
}

getPlannedLaborCost.PATH = '/v0/plannedLaborCosts/{id}';
